/** Turns a product name into a URL slug, e.g. "Congo Dust (Ankoro) Powder UK" → "congo-dust-ankoro-powder-uk" */
export function slugify(name: string): string {
  return name
    .toLowerCase()
    .trim()
    .replace(/[\s()[\]\/,]+/g, '-')
    .replace(/[^a-z0-9-]/g, '')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
}

export interface Product {
  id: number;
  name: string;
  slug: string;
  price: number;
  originalPrice: number;
  rating: number;
  reviews: number;
  image: string;
  tag: string;
  description: string;
  longDescription: string;
  usage: { title: string; steps: string[] };
  faqs: { question: string; answer: string }[];
  images?: string[];
}

export const products: Product[] = [
  {
    id: 1,
    name: "Congo Dust (Ankoro) Powder UK",
    slug: "congo-dust-ankoro-powder-uk",
    price: 19.99,
    originalPrice: 34.00,
    rating: 5,
    reviews: 124,
    image: "https://images.unsplash.com/photo-1615486511484-92e172cc4fe0?q=80&w=2000&auto=format&fit=crop",
    tag: "Topical Wellness Routine",
    description: "The gold standard for natural stamina support. This raw, potent powder is used by men who want the ultimate level of control without ingesting chemicals. It is the foundation of the Mufasa range.",
    longDescription: "Congo Dust (Ankoro) Powder UK is the ultimate key to unshakable stamina. If you are looking for a way to stay in control and unleash your inner beast, this traditional African root powder is your secret weapon.\n\nWhy Choose Raw Ankoro Powder?\n\nThis isn't just a powder; it's a foundational power. By applying a tiny pinch, you tap into centuries of African wellness traditions. These traditions were designed specifically to help men manage over-sensitivity and extend their performance naturally, without the need for numbing agents or synthetic chemicals.",
    usage: {
      title: "Step-by-Step Application Guide",
      steps: [
        "Moisten: Lightly wet your fingertip with water.",
        "Apply: Dip into the Ankoro powder and apply a small amount externally 30–45 minutes before intimacy.",
        "Activate: Allow the natural herbal alkaloids to absorb into the skin.",
        "Rinse: Wash your hands and wipe off any excess powder before contact to ensure total comfort."
      ]
    },
    faqs: [
      { question: "What happens if I use too much Congo Dust?", answer: "Because our Ankoro is 100% pure and highly potent, using too much can lead to an over-extended effect. We always recommend starting with a very small \"test\" pinch to see how your body responds to the Mufasa Energy." },
      { question: "Does it have a strong smell or taste?", answer: "The powder has a very mild, earthy, root-like scent. Once rinsed off after the absorption period, there is no discernible taste or smell, making it completely discreet for you and your partner." },
      { question: "How long will one jar of Congo Dust last?", answer: "Since you only need a tiny amount for each use, a single jar is designed to last for several months, making it one of the most cost-effective wellness products in your cabinet." },
      { question: "Is this product legal and safe in the UK?", answer: "Yes, our product consists of 100% natural herbal ingredients that are safe for topical use. We adhere to all UK safety guidelines to ensure you can use our products with total peace of mind." },
      { question: "Can I use it with lubricants?", answer: "Yes, once the powder has been absorbed and the excess wiped away, you can use your preferred lubricants as normal without affecting the performance of the Ankoro." }
    ]
  },
  {
    id: 2,
    name: "Congo Dust Sex Cream UK",
    slug: "congo-dust-sex-cream-uk",
    price: 15.99,
    originalPrice: 20.00,
    rating: 5,
    reviews: 89,
    image: "https://images.unsplash.com/photo-1620916566398-39f1143ab7be?w=800&q=80",
    tag: "Tactical Control Cream",
    description: "A fast-absorbing, smooth approach to timing. For the man who prefers a modern, discreet application that works within minutes. It is mess-free and fits perfectly into a fast-paced routine.",
    longDescription: "Congo Dust Sex Cream UK offers a refined, smooth-feel approach to timing control. If you prefer a clean finish and fast absorption, this tactical tool is built for your nightstand.\n\nThe Advantage of the Tactical Cream Format\n\nThe cream format is designed for the modern King who needs precision. It absorbs quickly into the skin, providing a reliable barrier against over-sensitivity while maintaining a raw, natural feel. It's discreet, effective, and mess-free—ideal for those who find raw powders less convenient.",
    usage: {
      title: "Application Instructions",
      steps: [
        "Apply a small amount externally 20–40 minutes before the moment.",
        "Massage in gently until fully absorbed.",
        "Rinse off any excess to ensure a clean experience for both partners."
      ]
    },
    faqs: [
      { question: "Is the cream better than the powder?", answer: "Neither is \"better\"—it's about preference. The powder is raw and traditional, while the cream is a modern, tactical formulation that many find easier to apply evenly." },
      { question: "Will it stain my bedsheets?", answer: "No. Our cream is formulated to be non-greasy and fast-absorbing. Once massaged in and rinsed, it leaves no residue or stains on fabrics." },
      { question: "Can I use the cream every time?", answer: "Yes, the cream is safe for regular use. It is made with natural herbal bases to be gentle on the skin while providing maximum control." },
      { question: "How discreet is the packaging of the cream?", answer: "The jar is small and looks like any other premium skincare product. It can sit on your nightstand or in a travel bag without drawing unnecessary attention." },
      { question: "Does the cream work instantly?", answer: "While it is fast-absorbing, we recommend at least 20 minutes to allow the herbal ingredients to fully penetrate and provide the desired level of support." }
    ]
  },
  {
    id: 3,
    name: "Green World VigPower Capsules UK",
    slug: "green-world-vigpower-capsules-uk",
    price: 44.35,
    originalPrice: 56.98,
    rating: 5,
    reviews: 215,
    image: "https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?w=800&q=80",
    tag: "Daily Vitality Support",
    description: "Your internal engine for consistent drive. These capsules are designed to be taken as a supplement to nourish the body from within, supporting blood flow and natural energy levels throughout the day.",
    longDescription: "Green World VigPower Capsules UK are the cornerstone of a consistent daily vitality routine. If you want to wake up feeling like a King and carry that Mufasa energy into your workday and your bedroom, this is your daily fuel.\n\nUnderstanding the Herbal Mechanism\n\nWe don't hide behind \"proprietary blends.\" Our capsules contain specific ingredients known for their masculine health benefits:\n\nSemen Cuscutae: Traditionally used to support kidney health and reproductive vigour.\n\nFructus Lycii: Packed with antioxidants to fight daily fatigue.\n\nRhizoma Dioscoreae: Supports healthy blood flow and hormonal balance.",
    usage: {
      title: "Recommended Usage",
      steps: [
        "Take 1 capsule daily with water.",
        "Or take 1-2 capsules 30 minutes before activity for a boost.",
        "Do not exceed 2 capsules in a 24-hour period."
      ]
    },
    faqs: [
      { question: "Do I need a prescription for VigPower Capsules?", answer: "No. VigPower is a 100% natural herbal food supplement. It does not contain controlled pharmaceutical ingredients, meaning you can order it freely and safely in the UK." },
      { question: "Can I take two capsules for a stronger effect?", answer: "We strongly advise following the recommended dosage on the label. The formula is balanced for safety and effectiveness; taking more than recommended is not necessary to achieve the Mufasa effect." },
      { question: "Is it okay to drink alcohol while taking VigPower?", answer: "While moderate alcohol consumption is generally fine, we recommend avoiding heavy drinking, as alcohol can naturally lower your energy and performance, counteracting the benefits of the capsules." },
      { question: "What is the shelf life of the capsules?", answer: "Our capsules typically have a shelf life of 2 years. Each bottle is marked with an expiry date to ensure you are always using the most potent product." },
      { question: "Are these capsules suitable for vegetarians?", answer: "Please check the specific batch label for casing information. We strive to use high-quality ingredients that are accessible to all Kings." }
    ]
  }
];
